import { gsap } from 'gsap';

/**
 * ANIMATIONS (GSAP) — un seul point d'entrée pour toute la borne, repris de
 * l'outil IGD pour que les outils du groupe bougent de la même façon.
 *
 * Le mouvement guide l'œil (la visite qui glisse d'un élément à l'autre) ; il
 * ne doit jamais retarder un geste ni gêner une personne sensible au
 * mouvement : `prefers-reduced-motion` coupe tout, et chaque animation reste
 * courte.
 */
export { gsap };

export function mouvementReduit(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * FILET DE SÉCURITÉ. GSAP avance au rythme de `requestAnimationFrame`, que le
 * navigateur GÈLE dans un onglet en arrière-plan : une entrée « depuis
 * l'opacité 0 » y resterait figée, et le contenu invisible au retour. Passé sa
 * durée prévue, l'animation est menée d'autorité à son terme — un contenu ne
 * doit jamais dépendre d'une animation pour être lisible.
 */
export function garantirFin<T extends gsap.core.Animation>(animation: T, marge = 400): T {
  const ms = animation.totalDuration() * 1000 + marge;
  if (Number.isFinite(ms)) {
    window.setTimeout(() => {
      // Une animation tuée entre-temps (remplacée par une plus récente) n'a plus
      // de parent : la terminer ferait revenir une valeur périmée.
      if (animation.parent && animation.progress() < 1) animation.progress(1);
    }, ms);
  }
  return animation;
}

/** Entrée en cascade d'une série d'éléments (cartes, lignes). */
export function entreeEnCascade(cibles: gsap.TweenTarget, decalage = 0.07): void {
  if (mouvementReduit()) return;
  garantirFin(gsap.from(cibles, { opacity: 0, y: 14, duration: 0.45, ease: 'power2.out', stagger: decalage, clearProps: 'opacity,transform' }));
}
